import { render, staticRenderFns } from "./SignUpFooter.vue?vue&type=template&id=45d64a88&"
import script from "./SignUpFooter.vue?vue&type=script&lang=js&"
export * from "./SignUpFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports